export default {"src":"/_next/static/media/saudi-arabia.2850df68.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};